import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ReportsResultsView = angular
  .module('acme.view.application.reports.results', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.reports.results.controllers',
  ])
  .config(function ($stateProvider) {
    const reportsResults = {
      name: 'application.reports.results',
      url: '/results?search',
      views: {
        'subview-main': {
          controller: 'ReportsResultsController',
          templateUrl: 'views/application/views/reports/results/results.tpl.html',
        },
      },
      data: {
        pageTitle: 'Results',
        permissions: ['REPORTS_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(reportsResults);
  }).name;
